export default {
  free_menu_items: 'Free unlocked',
  discount_badge: '{{value}} off',
  available_at_badge: 'Available {{schedule}}',
  restricted_tooltip: 'Available {{schedule}} — change pickup time above to order.',
};
